import { MDXProvider } from '@mdx-js/react'

import { mdComponentsConfig } from 'components/ui/Markdown'

import MdxWrapper from './components/MdxWrapper'

const MdxProvider = ({ children }: { children: JSX.Element }) => {
  return (
    <MDXProvider
      components={{
        ...mdComponentsConfig,
        wrapper: MdxWrapper,
      }}
    >
      {children}
    </MDXProvider>
  )
}

export default MdxProvider
